import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/user/user.module';
import { UserService } from '../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-recuperar',
  templateUrl: './recuperar.component.html',
  styleUrls: ['./recuperar.component.css']
})
export class RecuperarComponent implements OnInit {
  identity;
  user: User;
  status: string;
  loading: boolean = false;
  message: string;
  pass: string;
  constructor(private _userService: UserService, private _route: ActivatedRoute, private _router: Router) {
    this.user = new User(1, '', '', '', '', '', false);
  }

  ngOnInit(): void {
    this.identity = this._userService.getIdentity();
    if (this.identity != null) {
      this._router.navigate(["/"]);
    }

    this._route.params.subscribe(params => {
      this.user.name = params['id'];
    });

  }
  onSubmit(form) {
    //console.log(this.user);
    this.loading = true;
    if (this.user.password == this.user.img) {
      console.log(this.user);
      this.status == 'success';

      this._userService.reset_password(this.user).subscribe(
        response => {
          console.log(response);
          if (response.status == 'success') {
            this.status = 'success';
            this.message = response.message;
            this.loading = false;
            this._router.navigate(['login']);

          } else {
            this.status = 'error';
            console.log('error');
            this.message = response.message;
            this.loading = false;
          }
        },
        error => {
          this.message = 'Error';
          this.status = 'error';
          console.log(error);
          this.loading = false;
        }
      );
      //
    } else {
      this.pass = 'error';
      this.loading = false;
    }
  }



}
